import React from "react";

export const TIPO_COLOR = {
  vacaciones: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  asuntos_propios: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  baja_medica: "bg-red-500/15 text-red-300 border-red-500/30",
  permiso_retribuido: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  sin_sueldo: "bg-zinc-700/40 text-zinc-300 border-zinc-600",
  formacion: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  festivo_trasladado: "bg-pink-500/15 text-pink-300 border-pink-500/30",
  compensacion_horas: "bg-indigo-500/15 text-indigo-200 border-indigo-500/30",
};

export const ESTADO_COLOR = {
  pendiente: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  aprobada: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  rechazada: "bg-red-500/15 text-red-300 border-red-500/30",
  cancelada: "bg-zinc-700/40 text-zinc-400 border-zinc-600",
};

export const fmtH = (v, signed = true) => {
  const n = Number(v || 0);
  return `${signed && n > 0 ? "+" : ""}${n.toFixed(1)} h`;
};
export const fmtMin = (m) => `${Math.floor((m || 0) / 60)}h ${String((m || 0) % 60).padStart(2, "0")}`;
export const fmtHora = (iso) => iso ? new Date(iso).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Madrid" }) : "—";
export const fmtFecha = (ymd) => ymd ? new Date(`${ymd}T12:00:00`).toLocaleDateString("es-ES", { weekday: "short", day: "2-digit", month: "short" }) : "—";
export const mesLabel = (periodo) => new Date(`${periodo}-01T12:00:00`).toLocaleDateString("es-ES", { month: "long", year: "numeric" });
export const hoyPeriodo = () => new Date().toISOString().slice(0, 7);

export function EstadoBadge({ estado }) {
  return (
    <span className={`text-[10px] px-2 py-0.5 rounded border ${ESTADO_COLOR[estado] || ESTADO_COLOR.cancelada}`}
      data-testid={`estado-${estado}`}>{estado}</span>
  );
}

export function SaldoCard({ label, value, sub, color = "zinc", icon: Icon, testid, onClick }) {
  const txt = { emerald: "text-emerald-300", sky: "text-sky-300", red: "text-red-300", amber: "text-amber-300",
    violet: "text-violet-300", indigo: "text-indigo-200", zinc: "text-zinc-100" }[color] || "text-zinc-100";
  return (
    <div className={`bg-zinc-900/40 border border-zinc-800/60 rounded-lg p-3 ${onClick ? "cursor-pointer hover:border-zinc-600 transition-colors" : ""}`}
      data-testid={testid} onClick={onClick}>
      <div className="text-[10px] uppercase tracking-wider text-zinc-500 flex items-center gap-1">
        {Icon && <Icon className="w-3 h-3" />} {label}
      </div>
      <div className={`text-xl sm:text-2xl font-semibold mt-1 ${txt}`}>{value}</div>
      {sub && <div className="text-[10px] text-zinc-500 mt-1">{sub}</div>}
    </div>
  );
}

export function Panel({ title, icon: Icon, action, children, testid, className = "" }) {
  return (
    <div className={`bg-zinc-900/30 border border-zinc-800/60 rounded-lg overflow-hidden ${className}`} data-testid={testid}>
      <div className="px-4 py-2 text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-800 flex items-center gap-2">
        {Icon && <Icon className="w-3.5 h-3.5" />} {title}
        <span className="flex-1" />
        {action}
      </div>
      {children}
    </div>
  );
}
